module.exports = __webpack_public_path__ + "img/processing.830e61fb.svg";